import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * ProfessionalMyPageTabs のスタイル
 */
export const professionalMyPageTabsStyle = tv({
    slots: {
        tab: ['lg:pb-16'],
        tabButton: ['gap-8', 'min-h-[48px] lg:min-h-[64px]'],
        tabs: ['grid grid-cols-2 lg:grid-cols-4 gap-8'],
        text: [textStyle({ isBold: true, size: { initial: 'sm', lg: 'lg' } })],
    },
    variants: {
        selectedTab: {
            false: {
                tabButton: [
                    'bg-white hover:bg-navy-100',
                    'text-textGray hover:text-white',
                ],
            },
            true: {
                tab: [
                    'lg:relative',
                    // 矢印の表示
                    'lg:after:content-[""]',
                    'lg:after:rotate-90 lg:after:[clip-path:polygon(0_0,_0_100%,_100%_50%)]',
                    'lg:after:size-[16px]',
                    'lg:after:bg-navy-100',
                    'lg:after:absolute lg:after:bottom-0 lg:after:right-1/2',
                    'lg:after:translate-x-1/2',
                ],
                tabButton: ['bg-navy-100', 'text-white'],
            },
        },
    },
});
